export default __webpack_public_path__ + "static/media/marker-black-done.c2b29841.svg";